// JavaScript code for acf_blocks/visit-banner component
(($) => {
  "use strict";
  

  $(document).ready(() => {          // fires before images finish loading
		// Build timeline from the values already set in CSS
		gsap.timeline({ defaults: { ease: "power3.out" } })

		// headline cascade
		.to(".visit-banner-area__headline", {
			duration: 1.5,
			y: 0,              // CSS was +40
			opacity: 1,
			stagger: 0.25
		});           // overlap a bit
	});

	/* Close popover if the user taps the dark backdrop on mobile */
	document.addEventListener('pointerup', (ev) => {
		if (!window.matchMedia('(pointer:coarse), (max-width: 768px)').matches) return;

		// element under the finger
		const tgt = ev.target;

		// clicked *inside* an open popover? then do nothing
		if (tgt.closest('.popover')) return;

		// otherwise, hide whichever popover is open
		const open = document.querySelector('.popover.show');
		if (open) {
			bootstrap.Popover.getInstance(open)?.hide();
		}
	});
})(jQuery);
